
import { z } from "zod";

export const FinancingHistoryFieldValues = ["externalId", "requestForQuoteId", "vendor", "status", "loanAmount", "maxQualifiedAmount", "disbursedAmount", "fullyDisbursedDate", "finalizedDate", "loanDocumentsSignedAt", "creditExpirationDate", "apr", "termMonths", "monthlyPayment", "cancellationFee", "stipulations", "stipulationsSubmittedAt", "submissionError", "loanDocumentsSigningUrl", "isPlaceholder", "paymentMethod", "deletedAt"] as const;
export const FinancingHistoryFieldSchema = z.enum(FinancingHistoryFieldValues);
export const FinancingHistoryField = FinancingHistoryFieldSchema.enum;
export type FinancingHistoryField = (typeof FinancingHistoryFieldValues)[number];
